<template>
  <div>
    <nav class="navbar navbar-dark bg-dark justify-content-between flex-nowrap flex-row">
      <div class="container">
        <template v-if="auth_user.loggedIn">
          <a href="#" class="navbar-brand float-left" @click.prevent="goHome">
            <img src="../assets/logo.png" style="width: 160px;  margin-bottom: 10px;">
          </a>
          <ul class="nav navbar-nav flex-row float-right text-center">
            <li>
              <div class="nav-item">
                <span title="profilo" class="av-link px-2 mx-2 material-icons" @click.prevent="listPrices">
                  account_circle
                </span>
                <span style="color: #aaa">{{firstName}} @ </span>
                <span style="color: #aaa">{{auth_user.data.storeName}}</span>
              </div>
            </li>
            <li class="nav-item">
              <a class="nav-link px-2 mx-2" @click.prevent="signOut">Esci</a>
            </li>
          </ul>
        </template>
        <template v-else>
          <a href="/welcome" class="navbar-brand float-left">
            <img src="../assets/logo.png" style="width: 160px;  margin-bottom: 10px;">
          </a>
          <ul class="nav navbar-nav flex-row float-right text-center">
            <li class="nav-item">
              <router-link to="welcome" class="nav-link px-2 mx-2">Accedi</router-link>
            </li>
          </ul>
        </template>
      </div>
    </nav>
  </div>
</template>

<script>
  import { auth } from '../firebase/config.js';
  import { mapGetters } from 'vuex';

  export default {
    data() {
      return {
        userData: null,
      }
    },
    beforeMount() {
      window.addEventListener("beforeunload", this.preventNav)
      this.$once("hook:beforeDestroy", () => {
        window.removeEventListener("beforeunload", this.preventNav);
      })
    },
    computed: {
      ...mapGetters({
        // map `this.auth_user` to `this.$store.getters.user`
        auth_user: "user",
      }),
      firstName() {
        return this.auth_user.data.displayName.split(" ")[0]
      },
    },
    /*created() {
      // Retrieve data from sessionStorage
      const storedData = window.sessionStorage.getItem('userData');

      if (storedData) {
        // Parse the JSON string and set it to the component data
        this.userData = JSON.parse(storedData);
        console.log('userData on sessionStorage: ', this.userData)
        if(this.auth_user.data.storeName === null) {
          this.auth_user.data.storeName = this.userData.storeName
          console.log('store Name null -> storeName refresh: ', this.userData.storeName)
        }
      }
    },*/
    methods: {
      preventNav(event) {
        //if (!this.isEditing) return  //always prevent refresh, not only while editing
        event.preventDefault()
        // Set data in sessionStorage
        window.sessionStorage.setItem('userData', JSON.stringify({ 
          claims: this.auth_user.claims, storeName: this.auth_user.data.storeName }));
        event.returnValue = ""
        /*await auth.signOut()
        .then(() => {
          console.log('route path before -> ', this.$route.path)
          //this.auth_user.loggedIn = false
          this.$router.replace({ path: "../welcome" });
          console.log('route path before -> ', this.$route.path)
        })*/
      },
      goHome() {
        this.$router.replace({ name: "list_users" })
      },
      listPrices() {
        this.$router.replace({ name: "list_prices" })
      },
      signOut() {
        auth.signOut()
        .then(() => {
          //this.set_user_loggedIn(false)
          this.$router.replace({ name: "welcome" });
        })
      },
    }
  }
</script>